export interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  date: string;
  category: string;
  tags: string[];
  readingTime: string;
  isPublished: boolean;
  difficulty?: 'Beginner' | 'Intermediate' | 'Advanced';
  slug: string;
  Content?: React.ComponentType;
}

// Vite feature to dynamically import all .mdx files in the articles directory
const modules = import.meta.glob('../content/articles/*.mdx', { eager: true });

const allPosts: BlogPost[] = Object.entries(modules).map(([path, module]: [string, any]) => {
  // Extract slug from filename (e.g., ../content/articles/react-fiber.mdx -> react-fiber)
  const slug = path.split('/').pop()?.replace('.mdx', '') || '';
  
  return {
    ...module.meta,
    slug,
    Content: module.default,
  };
}).filter(post => post.isPublished); // Only keep published articles

export const getSortedPosts = () => {
  // Sort posts by date (newest first) or by ID for curated order
  return [...allPosts].sort((a, b) => b.id - a.id);
};

export const getPostById = (id: number) => {
  const sortedPosts = getSortedPosts();
  return sortedPosts.find(post => post.id === id) || null;
};

// Also support fetching by slug which is more SEO friendly for the future
export const getPostBySlug = (slug: string) => {
  const sortedPosts = getSortedPosts();
  return sortedPosts.find(post => post.slug === slug) || null;
};
